export * from './baAppPicture.pipe';



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/pipes/baAppPicture/index.ts